<template>
  <px-custom-dialog transition="fadet"
                    width="600"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Editando responsáveis
    </template>
    <template>
      <v-row class="mt-2">
        <px-autocomplete-user v-model="user"/>
        <v-btn icon x-large
               :loading="loading"
               :disabled="$v.$invalid"
               @click="onAdd">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>
      <v-subheader class="font-weight-bold mt-3">Responsáveis</v-subheader>
      <v-list>
        <template v-for="(admin, index) in responsaveis">
          <v-list-item :key="admin.id">
            <v-list-item-content>
              {{ admin.nome }}
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon :disabled="loadingRemove" @click="onRemoveAdmin(admin)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index !== (responsaveis.length - 1)"
                     :key="`v-div-usr-f${admin.id}`"/>
        </template>
      </v-list>
      <div v-if="!responsaveis || !responsaveis.length"
           align="center"
           class="subtitle-1 mb-5">
        Ainda não há nenhum responsável
      </div>
    </template>
  </px-custom-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import ResponsaveisService from './responsaveis-service';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    customPath: {
      type: String,
      required: true,
    },
    responsaveis: Array,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingRemove: false,
      user: null,
    };
  },
  methods: {
    onAdd() {
      this.loading = true;
      ResponsaveisService.add(this.customPath, this.id, this.user.id)
        .then(() => {
          this.$toast('Responsável adicionado', { color: 'success' });
          this.dialog = false;
          this.$emit('update');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRemoveAdmin(admin) {
      this.loadingRemove = true;
      ResponsaveisService.remove(this.customPath, this.id, admin.id)
        .then(() => {
          this.$toast('Responsável removido', { color: 'success' });
          this.dialog = false;
          this.$emit('update');
        })
        .finally(() => {
          this.loadingRemove = false;
        });
    },
    buildInitialState() {
      this.user = null;
      this.$v.$reset();
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.buildInitialState();
      }
    },
  },
  validations: {
    user: {
      required,
    },
  },
};
</script>
